import React, { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IStudent } from '../../../models/pushMessage.model';
import { DatePicker, Table, TableColumnsType } from 'antd';
import Button from '../../Button';
import config from '../../../lib/config';
import Pagination from '../../Pagination';
import styled from 'styled-components';
import Radio from '../../../components/Radio';
import EditTemplateModal from './modals/EditTemplateModal';
import moment, { Moment } from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import useNotification from '../../../hooks/useNotification';
import { sendMessages } from '../../../api/pushMessage.api';
import useAxios from '../../../hooks/useAxios';
import Loader from '../../Loader';
import ErrorResponse from '../../ErrorResponse';
import { useHistory } from 'react-router-dom';
import { IGetTemplates, ITemplate } from '../../../models/template.model';
import { deleteTemplate, getTemplates } from '../../../api/template.api';
import CustomTimePicker from '../../CustomTimePicker';
import useAuth from '../../../hooks/useAuth';
import SelectStudentModal from './modals/SelectStudentModal';
import UploadExcelModal from './modals/UploadExcelModal';
import { setStudents as setStoreStudents } from '../../../store/pushMessage.slice';
import ConfirmModal from './modals/ConfirmModal';
import PreviewModal from './modals/PreviewModal';
import Split from 'react-split';
import _ from 'lodash';

const Block = styled.div`
  .ant-table-wrapper {
    margin-top: 0;
  }

  .table-wrapper {
    margin-top: -20px;
  }
`;

const WriteMessage: FC = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { content, students: storeStudents } = useSelector(
    (root: RootState) => root.pushMessage,
  );
  const { infoNotification, successNotification } = useNotification();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { data: res, isLoading, error, execute } = useAxios<IGetTemplates>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();
  const {
    data: deleteRes,
    isLoading: deleteIsLoading,
    error: deleteError,
    execute: deleteExecute,
  } = useAxios();
  const GeneralMessageHead = `[${t('sms.send.text2')}] `;
  const AdvertiseMessageHead = `[${t('student.student.option21')}] `;

  const [page, setPage] = useState(1);
  const [studentPage, setStudentPage] = useState(1);
  const [sendType, setSendType] = useState('GE');
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState(content || GeneralMessageHead);
  const [sendTimeDiv, setSendTimeDiv] = useState('IM');
  const [sendDate, setSendDate] = useState('');
  const [sendTime, setSendTime] = useState('');
  const [outgoingNumber, setOutgoingNumber] = useState('');
  const [editTemplateVisible, setEditTemplateVisible] = useState(false);
  const [template, setTemplate] = useState<ITemplate>();
  const [sms, setSms] = useState(false);
  const [students, setStudents] = useState<IStudent[]>(storeStudents);
  const [selectStudentVisible, setSelectStudentVisible] = useState(false);
  const [uploadExcelVisible, setUploadExcelVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [targetStudent, setTargetStudent] = useState<IStudent>();

  const [replaceParams, setReplaceParams]  = useState<any[]>([]);


  
  

  useEffect(() => {
    doGetTemplates();

    // [수납 - 결제 대상] 메뉴에서 온 경우 처리
    const _students = sessionStorage.getItem('students');
    if (_students) {
      setStudents(JSON.parse(_students));
      sessionStorage.removeItem('students');
    }

    return () => {
      dispatch(
        setStoreStudents({
          content: '',
          students: [],
        }),
      );
    };
  }, []);

  useEffect(() => {
    const campus = campusData.find((item) => item.campusCode === currentCampus);
    if (campus) setOutgoingNumber(campus.telephoneNo);
  }, [currentCampus]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(
        `${
          sendTimeDiv === 'RE'
            ? t('sms.send.message1')
            : t('student.student.message46')
        }`,
      );
      history.push('/sms/member');
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      doGetTemplates();
      successNotification(t('common.message.delete'));
    }
  }, [deleteRes, deleteIsLoading]);


  const doGetTemplates = () => execute(getTemplates());

  const onSubmit = () => {
    if (
      sendDate === moment().format('YYYY-MM-DD') &&
      moment(sendTime, 'HH:mm').isBefore(moment())
    ) {
      return infoNotification(t('sms.send.1'));
    }

    const campus = campusData.find(
      ({ campusCode }) => campusCode === currentCampus,
    );
    if (!campus) return;
    if (!message) {
      return infoNotification(t('sms.send.message2'));
    }
    if (sendTimeDiv === 'RE' && (!sendDate || !sendTime)) {
      return infoNotification(t('sms.send.message3'));
    }
    if (!outgoingNumber) {
      return infoNotification(t('sms.send.message4'));
    }
    if (students.length === 0) {
      return infoNotification(t('sms.send.2'));
    }

    const req: any = {
      content: message,
      campusCode: currentCampus,
      sendType,
      sendTimeDiv,
      memberCode: students.map((item) => item.memberCode),
      outgoingNumber: campus.telephoneNo,
      isGroup: true,
      sms,
      reusePsbYN: 'Y',
      pushMessageReplace: students.map((item) => {
        const replaceStudent = replaceParams.find(replaceItem=> item.memberCode === replaceItem.memberCode);
        return {
          memberCode: item.memberCode,
          level: item.courseName,
          sub1: replaceStudent.sub1,
          sub2: replaceStudent.sub2
        }
      })
      
    };
    if (title) {
      req.title = title;
    }
    if (sendTimeDiv === 'RE') {
      req.sendDateTime = `${sendDate} ${sendTime}:00`;
    }
    submitExecute(sendMessages(req));
  };

  const onDeleteTemplate = (templateCode: number) => {
    deleteExecute(deleteTemplate(templateCode));
  };

  const onApplyTemplate = (template: ITemplate) => {
    setSendType(template.sendType);
    setTitle(template.title);
    setMessage(
      (template.sendType === 'GE' ? GeneralMessageHead : AdvertiseMessageHead) +
        template.content,
    );
  };

  const onDeleteStudent = (memberCode: string) => {
    const _students = students.filter(
      (student) => student.memberCode !== memberCode,
    );
    setStudents(_students);
  };

  const columns: TableColumnsType<any> = [
    {
      title: t('common.column.title'),
      dataIndex: 'title',
      key: 'title',
      align: 'center',
      sorter: (a, b) => a.title?.localeCompare(b.title),
    },
    {
      title: t('common.column.contents'),
      dataIndex: 'content',
      key: 'content',
      align: 'center',
      sorter: (a, b) => a.content?.localeCompare(b.content),
      render: (value) =>
        value.length > 45 ? `${value.substring(0, 45)}...` : value,
    },
    {
      title: t('sms.list.column2'),
      key: 'sendType',
      dataIndex: 'sendType',
      align: 'center',
      sorter: (a, b) => a.sendType?.localeCompare(b.sendType),
      render: (value) => {
        switch (value) {
          case 'GE':
            return t('student.student.option20');
          case 'AD':
            return t('student.student.option21');
          default:
            return value;
        }
      },
    },
    {
      title: '',
      dataIndex: 'templateCode',
      key: 'templateCode',
      align: 'center',
      width: '160px',
      render: (value, record) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small gray"
            onClickCapture={(e) => {
              e.stopPropagation();
              onDeleteTemplate(value);
            }}
            text={t('common.button.delete')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            className="btn-basic small mint"
            onClickCapture={(e) => {
              e.stopPropagation();
              onApplyTemplate(record);
            }}
            text={t('common.button.select')}
          />
        </div>
      ),
    },
  ];

  const customerColumns: TableColumnsType<IStudent> = [
    {
      title: 'No.',
      align: 'center',
      render: (value, record, index) => index + 1,
    },
    {
      title: t('student.student.placeholder2'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
    },
    {
      title: t('auth.login.label1'),
      dataIndex: 'webId',
      key: 'webId',
      align: 'center',
    },
    {
      title: t('sms.send.column1'),
      key: 'mobilePhone',
      dataIndex: 'mobilePhone',
      align: 'center',
    },
    {
      title: t('sms.send.3'),
      key: 'courseName',
      dataIndex: 'courseName',
      align: 'center',
    },
    {
      title: t('sms.send.4'),
      key: 'className',
      dataIndex: 'className',
      align: 'center',
    },
    {
      title: t('sms.send.7'),
      key: 'memberCode',
      dataIndex: 'sub1',
      align: 'center',
      render: (value, record) => {
        return (
          <input 
            type="text" 
            key={`sub1-${value}`} 
            className="form-control" 
            value={replaceParams.find((item)=> item.memberCode === record.memberCode)?.sub1 || ''}
            onChange={(e)=> onSetFocusStudentSub('sub1', record.memberCode, e.target.value)}
          />
        )
      }  
      
    },
    {
      title: t('sms.send.8'),
      key: 'sub2',
      dataIndex: 'sub2',
      align: 'center',
      render: (value, record) => (
        <input 
          type="text" 
          key={`sub2-${value}`} 
          className="form-control" 
          value={replaceParams.find((item)=> item.memberCode === record.memberCode)?.sub2 || ''}
          onChange={(e)=> onSetFocusStudentSub('sub2', record.memberCode, e.target.value)}
        />
      )
    },
    {
      title: t('common.button.preview'),
      dataIndex: 'memberCode',
      key: 'preview',
      align: 'center',
      render: (value) => (
        <div className='comm-btn__area'>
          <Button
            className="btn-basic small mint"
            onClick={() => showPreviewModal(value)}
            text={t('common.button.preview')}
          />
        </div>
      ),
    },
    {
      title: t('common.button.delete'),
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
      render: (value) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className="btn-basic small gray"
            onClick={() => onDeleteStudent(value)}
            text={t('common.button.delete')}
          />
        </div>
      ),
    },
  ];

  const disabledDate = (date: Moment) => {
    return date.isBefore(moment(new Date()).subtract(1, 'days'));
  };
  const disabledHours = () => {
    const currentDate = moment(new Date());
    const hourArray = Array.from({ length: 24 }, (v, k) => k);
    if (sendDate === currentDate.format('YYYY-MM-DD')) {
      return hourArray.filter((v) => v < currentDate.hour());
    } else {
      return [];
    }
  };

  // 학생 선택 후 Table Row 동작
  const [previewMessage, setPreviewMessage] = useState('');


  const onSetFocusStudentSub = (type: 'sub1' | 'sub2', memberCode: string, text: string) => {
    const replaceStudent = replaceParams.find((item)=> item.memberCode === memberCode);
    replaceStudent[type] = text;
    setReplaceParams([...replaceParams])
    
  }

  const replaceMessage = (message: string, student: any) => {
    const nameRegExp = new RegExp(`\{name\}`, 'gi');
    const levelRegExp = new RegExp(`\{level\}`, 'gi');
    const sub1RegExp = new RegExp(`\{sub1\}`, 'gi');
    const sub2RegExp = new RegExp(`\{sub2\}`, 'gi');

    const replaceStudent = replaceParams.find((item)=> item.memberCode === student.memberCode);
    setPreviewMessage(
      message
        .replace(nameRegExp, (i18n.language === 'ko' ? student?.memberName : student?.memberEngName) || '')
        .replace(levelRegExp, student?.courseName || '')
        .replace(sub1RegExp, replaceStudent?.sub1 || '')
        .replace(sub2RegExp, replaceStudent?.sub2 || '')
    ); 
  }

  const showConfirmModal = () => setConfirmVisible(true);
  const closeConfirmModal = () => setConfirmVisible(false);

  const showPreviewModal = (memberCode: string) => {
    replaceMessage(
      message, 
      students.find((item)=> item.memberCode === memberCode)
    );
    setPreviewVisible(true);
  }

  // 학생 선택 후 개발용 임시 세팅
  useEffect(()=> {
  setReplaceParams(
    [...students].map((item )=> (
      {
        memberCode: item.memberCode,
        sub1: item.sub1 || '',
        sub2: item.sub2 || ''
      })
    )
  );
  
  }, [students])

  return (
    <Block>
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <ErrorResponse error={deleteError} />

      <Split
        className="splite-divide"
        sizes={[40, 60]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        <div className="col-frame left_panel">
          <div className='comm-table__area rowType mt-0'>
            <table>
              <colgroup>
                <col width="20%" />
                <col width="80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th className="text-center" colSpan={2}>
                    {t('student.student.column57')}
                  </th>
                </tr>
                <tr>
                  <th className="text-center">{t('sms.list.column2')}</th>
                  <td>
                    <Radio
                      checked={sendType === 'GE'}
                      onChange={() => {
                        setSendType('GE');
                        setMessage(GeneralMessageHead);
                      }}
                      text={t('student.student.option20')}
                    />
                    <Radio
                      className="ml-4"
                      checked={sendType === 'AD'}
                      onChange={() => {
                        setSendType('AD');
                        setMessage(AdvertiseMessageHead);
                      }}
                      text={t('student.student.option21')}
                    />
                  </td>
                </tr>
                <tr>
                  <th className="text-center">{t('common.column.title')}</th>
                  <td>
                    <input
                      type="text"
                      className="form-control input-text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <th className="text-center">{t('common.column.contents')}</th>
                  <td>
                    <textarea
                      className="w-100"
                      rows={5}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                    <p className="mt-3">
                      <b>{t('sms.send.text6')}</b><br/>
                      {t('sms.send.text7')}<br/>
                      {t('sms.send.text8')}<br/>
                      {t('sms.send.text9')}<br/>
                      {t('sms.send.text10')}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th className="text-center">{t('sms.list.column3')}</th>
                  <td>
                    <div className='comm-gap'>
                      <div>
                        <Radio
                          checked={sendTimeDiv === 'IM'}
                          onChange={() => setSendTimeDiv('IM')}
                          text={t('student.student.option22')}
                        />
                        <Radio
                          className="ml-4"
                          checked={sendTimeDiv === 'RE'}
                          onChange={() => setSendTimeDiv('RE')}
                          text={t('student.student.option23')}
                        />
                      </div>
                      <div className="date-picker__area">
                        <DatePicker
                          className="w-120p ml-1"
                          value={sendDate ? moment(sendDate) : undefined}
                          onChange={(e) => {
                            if (e === null) setSendDate('');
                            else setSendDate(moment(e).format('YYYY-MM-DD'));
                          }}
                          disabled={sendTimeDiv !== 'RE'}
                          disabledDate={disabledDate}
                        />
                      </div>
                      <div className="time-picker__area">
                        <CustomTimePicker
                          value={sendTime}
                          onSelect={(value) => {
                            if (value) setSendTime(moment(value).format('HH:mm'));
                            else setSendTime('');
                          }}
                          disabledHours={disabledHours}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th className="text-center">
                    {t('student.student.column122')}
                  </th>
                  <td>
                    <Radio
                      checked={!sms}
                      onChange={() => setSms(false)}
                      text={t('student.student.option29')}
                    />
                    <Radio
                      className="ml-4"
                      checked={sms}
                      onChange={() => setSms(true)}
                      text={t('student.student.option30')}
                    />
                  </td>
                </tr>
                <tr>
                  <th className="text-center">{t('sms.send.column2')}</th>
                  <td>
                    <input
                      type="text"
                      className="form-control input-text"
                      placeholder={t('student.student.placeholder8')}
                      value={outgoingNumber}
                      onChange={(e) => setOutgoingNumber(e.target.value)}
                      disabled
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="comm-bx__space">
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink-line"
                onClick={() => setSelectStudentVisible(true)}
                text={t('sms.send.button1')}
                writeAuthYn={writeAuthYn}
              />
              <Button
                className="btn-basic pink-line"
                onClick={() => setUploadExcelVisible(true)}
                text={t('sms.send.button2')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
          <div className='comm-table__area'>
            <Table
              columns={customerColumns}
              dataSource={students}
              pagination={{
                current: studentPage,
                pageSize: config.smallPageSize,
              }}
            />
          </div>
          <div className="comm-bx__between">
            <div />
            <div className="common-paging center">
              <Pagination
                count={students.length}
                page={studentPage}
                setPage={setStudentPage}
                small
              />
            </div>
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink-line"
                onClick={showConfirmModal}
                text={t('student.student.button24')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>

        </div>
        <div className="col-frame right_panel">
          <div className="comm-table__area mt-0">
            <Table
              columns={columns}
              dataSource={res?.data}
              pagination={{
                current: page,
                pageSize: config.smallPageSize,
              }}
              onRow={(record) => {
                return {
                  onClick: () => {
                    setTemplate(record);
                    setEditTemplateVisible(true);
                  },
                };
              }}
              rowClassName="pointer"
              rowKey="messageCode"
            />
          </div>
          <div className="comm-bx__between">
            <div className="comm-btn__area">
              <Button
                className="btn-basic gray-line"
                onClick={() => history.goBack()}
                text={t('common.button.back')}
              />
            </div>
            <div className="common-paging center">
              <Pagination
                count={res?.data.length || 0}
                page={page}
                setPage={setPage}
              />
            </div>
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink-line"
                onClick={() => setEditTemplateVisible(true)}
                text={t('sms.send.button4')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
        </div>
      </Split>

      {selectStudentVisible && (
        <SelectStudentModal
          visible={selectStudentVisible}
          setVisible={setSelectStudentVisible}
          students={students}
          setStudents={setStudents}
        />
      )}
      {editTemplateVisible && (
        <EditTemplateModal
          visible={editTemplateVisible}
          setVisible={setEditTemplateVisible}
          doGetTemplates={doGetTemplates}
          template={template}
          setTemplate={setTemplate}
        />
      )}
      {uploadExcelVisible && (
        <UploadExcelModal
          visible={uploadExcelVisible}
          setVisible={setUploadExcelVisible}
          students={students}
          setStudents={setStudents}
        />
      )}
      {confirmVisible && (
        <ConfirmModal
          visible={confirmVisible}
          setVisible={setConfirmVisible}
          onCancel={closeConfirmModal}
          onOk={onSubmit}
        />
      )}
      {previewVisible && (
        <PreviewModal
          visible={previewVisible}
          setVisible={setPreviewVisible}
          student={targetStudent}
          data={previewMessage}
        />
      )}
    </Block>
  );
};

export default WriteMessage;
